import styled, {keyframes} from 'styled-components';
import SearchInputIcon from '../../../../Icons/SearchInputIcon';

export const SearchResultsLoaderContainer = styled.div(
  props => `   
      display:flex;
      flex-direction:column;
      justify-content:center;
      align-items:center;
      width: 40rem;
      height: 25rem;
      border-radius: ${props.theme.misc.borderRadius.custom(30)};
      background: ${props.theme.colors.goWhite.base};
      padding: 0 ${props.theme.spacing.custom(10)};
      margin: ${props.theme.spacing.custom(10)} auto;
      position: sticky;
      top: ${props.theme.spacing.custom(320)};
    `,
);

export const SearchresultLoadericonsWrap = styled.div(
  props => `   
      display:flex;
      align-items: center;
      position:relative;
      width: 100%;
      justify-content: space-around;
      padding-bottom: ${props.theme.spacing.xxlarge};
    `,
);

export const SearchResultsLoaderLabel = styled.p(
  props => `   
    font-size:${props.theme.font.custom(16)};
    font-family:${props.theme.font.fontFamily};
    font-weight:bold;
    color: ${props.theme.colors.goBrandBlue.base};
    text-transform:uppercase;
    padding: ${props.theme.spacing.small};
    `,
);

export const SearchResultsLoaderSubLabel = styled.p(
  props => `   
    font-size:${props.theme.font.custom(16)};
    color: ${props.theme.colors.downriver.medium};
    text-align:center;
    `,
);

export const SearchInputIconWrap = styled(SearchInputIcon)(
  props => `
    width:6rem;
    height:6rem;
    position:absolute;
    left:45%;
    fill:${props.theme.colors.goBrandBlue.base};
  `,
);

export const OverlayBackround = styled.div(
  props => `

  background-color: rgba(0,0,0,0.2);
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  align-items:center;
  border-radius: ${props.theme.spacing.custom(12)};
  `,
);
